import React from 'react'
import ExperienceCard from '../components/Experience/experience-card'
import SectionContainer from '../components/section-container'
import SectionTitle from '../components/section-title'

const experiences = [
  {
    logo: 'assets/images/companies/pinkaloo.png',
    title: 'Full Stack Engineer',
    subtitle: 'Pinkaloo Technologies',
    date: 'May 2019 - Nov 2020',
    location: 'Baltimore, MD',
    description: [
      'Participated in building internal applications',
      'Collaborated with product/marketing teams to redesign the mobile/Tablet/Desktop onboarding process and user experience by 40%',
      'Developed 5+ full stack features using Javascript/Typescript, React/NextJs, Node/Express.js, MongoDB/Mongoose',
      'Led redesign of website and competitive research, increasing website leads by 200%',
      'Facilitated Rest API build/integration such as PayPal, Stripe, FB, Google',
      'Extracted 10+ kinds of data from data sources including RDBMS (MySQL, Oracle, SQL Server) and performed data transformation and loading process into target environment using loads strategies including incremented load and full load',
    ],
  },
  {
    logo: 'assets/images/companies/mclane.jpg',
    title: 'Frontend Developer',
    subtitle: 'McLane Company',
    date: 'Feb 2017 - Apr 2019',
    location: 'Temple, TX',
    description: [
      'Mainly worked as a frontend developer',
      'React/Redux-Toolkit for front-end and Node/Express for back-end, MongoDB for database',
      'Setup and maintained CI/CD pipelines to multiple environments including backend, web and mobile app beta and production distributions using GitHub Actions and GitLab CI/CD',
      'Used both MUI, Styles and styled components for component styling used component-container pattern. Used Jest for unit testing',
      'Worked on refactoring class components to functional components using React Hooks',
    ],
  },
  {
    logo: 'assets/images/companies/fueledonbacon.png',
    title: 'Web3 Frontend Engineer',
    subtitle: 'Fueled on Bacon',
    date: 'Sep 2021 - Oct 2022',
    location: 'Tallahassee, FL',
    description: [
      'Worked with React | Vue v2 & v3. Involved in building UI/UX and architectural decisions as a senior developer',
      'Frontend Web3 integration, Smart Contract and Node/Express Backend stuffs for Dapps on EVM compatible networks and Solana',
      'Mentoring junior developers and knowledge transfer sessions to bring new technologies',
      'Worked in scrum method and participated in daily standups for sharing ideas and workflow',
    ],
  },
]

const educations = [
  {
    logo: 'assets/images/companies/Belgarade UN.jfif',
    title: 'Bachelor of Engineering, Major in Computer Science',
    subtitle: 'Belgrade University',
    date: '2012 - 2016',
    location: 'Belgrade, Serbia',
  },
]

const ExperienceSection = () => {
  return (
    <SectionContainer
      addClass="bg-[linear-gradient(rgba(0,0,0,0.66),rgba(0,0,0,0.8),#000)]"
      id="experience"
    >
      <SectionTitle>Experience</SectionTitle>
      <div className="mx-auto mt-10 mb-24 flex max-w-[900px] flex-col gap-8 md:mt-0 2xl:max-w-[1185px]">
        {experiences.map((exp, i) => (
          <ExperienceCard key={`experience-card-${i}`} {...exp} />
        ))}
      </div>
      <SectionTitle>Education</SectionTitle>
      <div className="mx-auto mt-10 flex max-w-[900px] flex-col gap-8 md:mt-0 2xl:max-w-[1185px]">
        {educations.map((edu, i) => (
          <ExperienceCard key={`education-card-${i}`} {...edu} />
        ))}
      </div>
    </SectionContainer>
  )
}

export default ExperienceSection
